import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import {
  AppBar, Box, Button, Divider, IconButton, Toolbar, Typography, useTheme,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { LogoCiatIcon } from '../Styled/Buttons/icons';
import { InfoButton } from '../Styled/Buttons';
import Message from '../../containers/Message';
import { AppContext } from '../../providers/authProvider';

function Header({ menuExpanded }) {
  const { currentUser } = useContext(AppContext);
  const theme = useTheme();
  const t = theme.transitions.create(['left']);
  return (
    <AppBar
      position="fixed"
      elevation={2}
      sx={{
        transition: t,
        position: 'fixed',
        width: 'auto',
        height: theme.menu.height,
        bgcolor: 'grey.100',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        left: menuExpanded ? theme.menu.expanded.width : theme.menu.shrinked.width,
        top: 0,
        right: 0,
        px: 4,
        zIndex: 1,
      }}
    >
      <Box>
        {currentUser.org && currentUser.org.logo && (
          <Button
            startIcon={<img src={LogoCiatIcon} alt="ЦІАТ" title="ЦІАТ" height={32} />}
            href="https://ciat.net.ua/uk/"
            target="_blank"
          >
            <Typography variant="h6">
              Центр інформаційних та аналітичних технологій
            </Typography>
          </Button>
        )}
      </Box>
      <Toolbar sx={{ ml: 'auto' }}>
        <IconButton
          href="https://www.facebook.com/ciat.net.ua/"
          target="_blank"
          rel="noopener noreferrer"
          color="primary"
        >
          <FontAwesomeIcon icon={faFacebook} />
        </IconButton>
        <InfoButton />
        <Message />
        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
        <Box textAlign="right">
          <Typography variant="body1" color="primary">
            {`Доброго дня ${currentUser.first_name || currentUser.username} ${currentUser.last_name}. `}
          </Typography>
          {currentUser.org && currentUser.org.id ? (
            <Typography variant="body2" color="secondary">
              {`Установа ${currentUser.org.repr}`}
            </Typography>
          ) : (
            <Typography variant="body2" color="error">
              Не задана установа
            </Typography>
          )}
        </Box>
      </Toolbar>
      {/* </StyledHeader> */}
    </AppBar>
  );
}
Header.propTypes = {
  menuExpanded: PropTypes.bool.isRequired,
};

export default memo(Header);
